module.exports = __webpack_public_path__ + "media/images/svgs/jobs/calendar-white-97377ea781e2164d4ca537033cfd61e6.svg";